import { Menu, Tooltip, type MenuPlacement, type TooltipPlacement, useMediaState } from '@vidstack/react';
import { SpeedSubmenu } from "@/components/player/layouts/shared/menus/speed-menu";
import { QualitySubmenu } from "@/components/player/layouts/shared/menus/quality-menu";
import { CaptionsStyleSubmenu } from "@/components/player/layouts/shared/menus/captions-style-menu";
import { BraivSettingsIcon } from "@/components/player/layouts/shared/playerIcons";
import { LanguagesSubMenu } from "@/components/player/layouts/shared/menus/languagesSubMenu";
import { LanguageMenuLocation } from "@/lib/types";
export interface SettingsProps {
  placement: MenuPlacement;
  tooltipPlacement: TooltipPlacement;
  portalClass?: string;
  showPortal?: boolean;
  languageMenuSettings?: {
    languageMenuLocation?: LanguageMenuLocation;
    displayFlags?: boolean;
  };
}
export function SettingsMenu({
  tooltipPlacement,
  placement,
  portalClass,
  showPortal,
  languageMenuSettings
}: SettingsProps) {
  const viewType = useMediaState('viewType');
  return <Menu.Root className="vds-settings-menu vds-menu" data-sentry-element="unknown" data-sentry-component="SettingsMenu" data-sentry-source-file="settings-menus.tsx">
            <Tooltip.Root data-sentry-element="unknown" data-sentry-source-file="settings-menus.tsx">
                <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="settings-menus.tsx">
                    <Menu.Button className="vds-menu-button vds-button" data-sentry-element="unknown" data-sentry-source-file="settings-menus.tsx">
                        <BraivSettingsIcon className="vds-rotate-icon" data-sentry-element="BraivSettingsIcon" data-sentry-source-file="settings-menus.tsx" />
                    </Menu.Button>
                </Tooltip.Trigger>
                <Tooltip.Content className="vds-tooltip-content" placement={tooltipPlacement} data-sentry-element="unknown" data-sentry-source-file="settings-menus.tsx">
                    Settings
                </Tooltip.Content>
            </Tooltip.Root>
            <Menu.Portal className={`${portalClass ? portalClass : ''}`} disabled={"fullscreen"} data-view-type={viewType} data-sentry-element="unknown" data-sentry-source-file="settings-menus.tsx">
                <Menu.Content className="vds-settings-menu-items vds-menu-items" placement={!showPortal ? placement : null} //If we want to show the portal set the placement to null
      data-sentry-element="unknown" data-sentry-source-file="settings-menus.tsx">
                    {languageMenuSettings?.languageMenuLocation === "settings" ? <LanguagesSubMenu displayFlags={!!languageMenuSettings.displayFlags} /> : null}
                    <SpeedSubmenu data-sentry-element="SpeedSubmenu" data-sentry-source-file="settings-menus.tsx" />
                    <QualitySubmenu data-sentry-element="QualitySubmenu" data-sentry-source-file="settings-menus.tsx" />
                    {/*<AudioSubmenu/>*/}
                    {/*<CaptionsSubmenu/>*/}
                    <CaptionsStyleSubmenu data-sentry-element="CaptionsStyleSubmenu" data-sentry-source-file="settings-menus.tsx" />
                </Menu.Content>
            </Menu.Portal>
        </Menu.Root>;
}